import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/thumbs-up",
  "use": "app/thumbs-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/thumbs-up\"><path d=\"M6.617 22.545V10.06L11.955.525s2.96-.475 2.96 3v4.418h3.973c3.04 0 5.214 2.939 4.326 5.846l-1.697 5.554a4.524 4.524 0 01-4.326 3.202H6.617zM1 12.053c0-.833.675-1.508 1.508-1.508H4.79v12H2.508A1.508 1.508 0 011 21.037v-8.984z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol